import { render, staticRenderFns } from "./HostingAddOn.vue?vue&type=template&id=746b4062&"
import script from "./HostingAddOn.vue?vue&type=script&lang=js&"
export * from "./HostingAddOn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports